import api from "../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY || 'http://localhost:3000/';

/**
 * Crea una cotizacion a partir de una ruta
 * @param {Object} data - Datos del trazo
 * @returns {Promise<Object>} - Respuesta del servidor
 */
export const createQuoteFromRoute = async (data) => {
    try {
        const res = await api.post(`${urlApi}/quotes/createQuoteFromRoute`, data);
        return res.data;
    } catch (error) {
        console.error("Error guardando ruta:", error);
        throw error;
    }
};

/** Obtiene una cotización existente por ID para pre-poblar el wizard */
export const getQuoteById = async (cotId) => {
    try {
        const res = await api.get(`${urlApi}/quotes/quote/mod/${cotId}`);
        return res.data;
    } catch (error) {
        console.error("Error obteniendo cotización:", error);
        throw error;
    }
};

/** Actualiza una cotización existente */
export const updateQuoteFromRoute = async (data) => {
    try {
        const res = await api.put(`${urlApi}/quotes/updateQuoteFromRoute`, data);
        return res.data;
    } catch (error) {
        console.error("Error actualizando cotización:", error);
        throw error;
    }
};

/** Obtiene la unidad predominante y recomendación de cambio basada en los últimos 30 días */
export const getRecomendacionUnidad = async (rutaId) => {
    try {
        const res = await api.get(`${urlApi}/quotes/route/${rutaId}/bestUnit`);
        return res.data;
    } catch (error) {
        console.error("Error obteniendo recomendación de unidad:", error);
        throw error;
    }
};
